import {
    keyIssueListPageRequest,
    keyIssueItemRequest
} from "../../../actions/key-issue-actions"

import buildListContainer from "../../common/build-list-container"
import KeyIssueListItem from "./KeyIssueListItem"
import KeyIssueListItemShadow from "./KeyIssueListItemShadow"

export default buildListContainer(
    KeyIssueListItem,
    KeyIssueListItemShadow,
    keyIssueListPageRequest,
    keyIssueItemRequest,
    "keyIssues",
    "dimensions"
)
